import axios, { AxiosRequestConfig } from "axios";
import { backEndAPI } from "../serviceHelper/axios";
import {
  ERROR_MESSAGES,
  HTTP_STATUS_CREATED,
  HTTP_STATUS_OK,
  httpMethods,
} from "../../constants/appConstants";

const cancelTokens = new Map();

const validateResponse = (response: any) => {
  if (
    response.status !== HTTP_STATUS_OK &&
    response.status !== HTTP_STATUS_CREATED
  ) {
    throw new Error(ERROR_MESSAGES.NETWORK_RESPONSE_NOT_OK);
  } else {
    return response;
  }
};

export const sendRequest = async (
  type: string,
  url: string,
  data?: AxiosRequestConfig,
  requestId?: string
) => {
  try {
    if (cancelTokens.has(requestId)) {
      const cancelTokenSource = cancelTokens.get(requestId);
      cancelTokenSource.cancel(ERROR_MESSAGES.CANCEL_PREVIOUS_REQUEST);
      cancelTokens.delete(requestId);
    }

    let config: AxiosRequestConfig = {
      ...data,
    };

    if (requestId) {
      const newCancelTokenSource = axios.CancelToken.source();
      cancelTokens.set(requestId, newCancelTokenSource);
      config = {
        ...config,
        cancelToken: newCancelTokenSource.token,
      };
    }

    const requestPromise = (() => {
      switch (type) {
        case httpMethods.GET:
          return backEndAPI.get(url, config);
        case httpMethods.POST:
          return backEndAPI.post(url, config);
        case httpMethods.PUT:
          return backEndAPI.put(url, config);
        case httpMethods.PATCH:
          return backEndAPI.patch(url, config);
        case httpMethods.DELETE:
          return backEndAPI.delete(url, config);
        default:
          throw new Error(ERROR_MESSAGES.ERROR_INVALID_HTTP_METHOD);
      }
    })();

    const result = await Promise.race([requestPromise]);

    cancelTokens.delete(requestId);
    return validateResponse(result);
  } catch (error) {
    if (axios.isCancel(error)) {
    } else {
      throw error;
    }
  }
};

export const readCookie = (name: string) => {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? decodeURIComponent(match[2]) : null;
};
